const CARD  = "#0e1220";
const CARD2 = "#131b2e";
const BD    = "#1c2540";
const TX    = "#c8d8f0";
const TX2   = "#4a5c7a";
const GR    = "#00e676";
const BL    = "#29b6f6";
const RD    = "#ef5350";

export default function TOS({ onClose }) {
  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, backdropFilter: "blur(6px)" }}
      onClick={onClose}
    >
      <div
        style={{ background: CARD, border: `1px solid ${BD}`, borderRadius: 16, maxWidth: 600, width: "100%", maxHeight: "88vh", display: "flex", flexDirection: "column", boxShadow: "0 32px 80px rgba(0,0,0,0.7)" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ padding: "18px 24px 16px", borderBottom: `1px solid ${BD}`, display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
          <div>
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 800, fontSize: 16, color: TX }}>Terms of Service</div>
            <div style={{ fontSize: 9, color: TX2, marginTop: 3, letterSpacing: 1 }}>Last updated March 2026 · Trade Scanner</div>
          </div>
          <button onClick={onClose} style={{ background: CARD2, border: `1px solid ${BD}`, borderRadius: 6, padding: "5px 11px", color: TX2, fontSize: 12, cursor: "pointer", fontFamily: "'IBM Plex Mono',monospace" }}>✕</button>
        </div>

        {/* Scrollable content */}
        <div style={{ overflowY: "auto", padding: "20px 24px 28px", fontSize: 11, color: TX2, lineHeight: 1.8, fontFamily: "'IBM Plex Mono',monospace" }}>

          <Section title="1. Educational Tool Only">
            Trade Scanner is provided <strong style={{ color: TX }}>for educational and informational purposes only</strong>. Nothing on this platform constitutes financial, investment, or trading advice. All content is for learning and research purposes.
          </Section>

          <Section title="2. Not Financial Advice">
            The scores, signals, and projections generated by Trade Scanner <strong style={{ color: RD }}>do not constitute financial advice</strong>. You should not make real trading decisions based solely on information from this tool without conducting your own research and consulting a licensed financial advisor.
          </Section>

          <Section title="3. No Guarantee of Profits">
            Trade Scanner makes <strong style={{ color: TX }}>no guarantees of profits or returns</strong>. Past scan results, backtest performance, and signal history do not guarantee future results. Markets are inherently unpredictable and all trading involves risk of loss.
          </Section>

          <Section title="4. User Assumes All Risk">
            By using Trade Scanner, you acknowledge that <strong style={{ color: TX }}>you assume full responsibility</strong> for any trading decisions you make. The developers and operators of Trade Scanner accept no liability for trading losses, missed opportunities, or financial harm resulting from use of this platform.
          </Section>

          <Section title="5. Data Accuracy Disclaimer">
            Market data displayed on Trade Scanner may be <strong style={{ color: TX }}>delayed, incomplete, or incorrect</strong>. Data is sourced from third-party providers (Finnhub, Yahoo Finance, Financial Modeling Prep) and may not reflect real-time conditions. Always verify data with your broker before executing trades.
          </Section>

          <Section title="6. No Liability for Losses">
            Trade Scanner, its creators, contributors, and affiliates are <strong style={{ color: RD }}>not liable for any direct, indirect, incidental, or consequential losses</strong> arising from use of this platform, including but not limited to trading losses, data errors, platform downtime, or signal inaccuracies.
          </Section>

          <Section title="7. Age Requirement">
            You must be <strong style={{ color: GR }}>18 years or older</strong> to trade real money in financial markets. The paper trading feature is available for educational purposes. If you are under 18, you may use the paper trading simulation only.
          </Section>

          <Section title="8. Data Sources">
            Trade Scanner uses data from the following third-party providers:
            <ul style={{ marginTop: 8, paddingLeft: 18, display: "flex", flexDirection: "column", gap: 4 }}>
              <li><span style={{ color: BL }}>Finnhub</span> — real-time stock quotes, earnings, insider transactions</li>
              <li><span style={{ color: BL }}>Yahoo Finance</span> — historical price candles, VIX data</li>
              <li><span style={{ color: BL }}>Financial Modeling Prep (FMP)</span> — additional fundamental data</li>
            </ul>
            <div style={{ marginTop: 8 }}>These providers have their own terms of service which may restrict certain uses of their data.</div>
          </Section>

          <Section title="9. Paper Trading">
            The paper trading feature uses a <strong style={{ color: TX }}>simulated virtual balance</strong>. No real money is involved. Paper trading results do not reflect actual market execution and should not be used to predict real trading performance.
          </Section>

          <Section title="10. Changes to Terms">
            We reserve the right to update these terms at any time. Continued use of Trade Scanner after changes constitutes acceptance of the revised terms.
          </Section>

          <div style={{ marginTop: 24, padding: "14px 16px", background: CARD2, border: `1px solid ${BD}`, borderRadius: 10, fontSize: 10, color: TX2, lineHeight: 1.7 }}>
            By using Trade Scanner, you confirm that you have read, understood, and agree to these terms. If you do not agree, please do not use this platform.
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: "14px 24px", borderTop: `1px solid ${BD}`, flexShrink: 0, display: "flex", justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ background: `linear-gradient(135deg,${GR},${BL})`, border: "none", borderRadius: 8, padding: "10px 24px", color: "#000", fontSize: 10, fontWeight: 800, cursor: "pointer", letterSpacing: 2, fontFamily: "'IBM Plex Mono',monospace" }}>
            I UNDERSTAND →
          </button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ fontSize: 10, fontWeight: 700, color: "#c8d8f0", marginBottom: 6, letterSpacing: 0.5 }}>{title}</div>
      <div>{children}</div>
    </div>
  );
}
